<template>
	<div class="pool-asset-icon" :class="sizeClass" :style="wrapStyle">
		<img
			v-if="effectiveLogoUrl"
			:src="effectiveLogoUrl"
			class="pool-asset-icon-img"
			alt=""
			@error="onLogoError"
		/>
		<span v-else class="pool-asset-icon-letter">{{ iconLetter }}</span>
	</div>
</template>

<script>
const ICON_COLORS = ['#84cc16', '#3b82f6', '#a855f7', '#f59e0b', '#14b8a6', '#ef4444', '#ec4899']

export default {
	name: 'PoolAssetIcon',
	props: {
		symbol: {
			type: String,
			default: ''
		},
		logoUrl: {
			type: String,
			default: ''
		},
		/** default | sm | lg */
		size: {
			type: String,
			default: 'default'
		}
	},
	data() {
		return {
			logoBroken: false
		}
	},
	computed: {
		sizeClass() {
			return this.size === 'default' ? null : this.size
		},
		effectiveLogoUrl() {
			if (this.logoBroken) return ''
			const url = (this.logoUrl || '').trim()
			return url
		},
		iconLetter() {
			const s = (this.symbol || '?').toString()
			return s.charAt(0).toUpperCase()
		},
		wrapStyle() {
			return {
				background: this.effectiveLogoUrl ? 'transparent' : this.iconColor(this.symbol)
			}
		}
	},
	watch: {
		logoUrl() {
			this.logoBroken = false
		},
		symbol() {
			this.logoBroken = false
		}
	},
	methods: {
		iconColor(symbol) {
			const s = (symbol || '').toString()
			let hash = 0
			for (let i = 0; i < s.length; i++) hash = (hash + s.charCodeAt(i) * (i + 1)) % ICON_COLORS.length
			return ICON_COLORS[hash]
		},
		onLogoError() {
			this.logoBroken = true
		}
	}
}
</script>

<style scoped lang="scss">
.pool-asset-icon {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	font-size: 15px;
	color: var(--ld-text, #111111);
	flex-shrink: 0;
	overflow: hidden;

	&.sm {
		width: 32px;
		height: 32px;
		font-size: 13px;
	}

	&.lg {
		width: 48px;
		height: 48px;
		font-size: 20px;
	}
}

.pool-asset-icon-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 50%;
	display: block;
}

.pool-asset-icon-letter {
	line-height: 1;
}
</style>
